module.exports = __webpack_public_path__ + "static/media/clack.d94d96e6.mp3";